import React, { useCallback } from 'react'

import TextField from '@mui/material/TextField'
import styled from 'styled-components'

import { textColor } from '../Colors'
import { textFont } from '../Fonts'

const TextInputNative = styled(TextField)`
  border-width: 0;
  font-family: ${textFont};
  padding-top: 0;
  padding-bottom: 0;
  color: ${textColor};
`

export const Input = styled(TextField)`
  border-width: 0;
  font-family: ${textFont};
  padding-top: 0;
  padding-bottom: 0;
  color: ${textColor};
`
type Props = {
  placeholder?: string
  autoCapitalize?: 'none' | 'sentences' | 'words' | 'characters'
  autoCorrect?: boolean
  enablesReturnKeyAutomatically?: boolean
  value: string
  onChangeText: (text: string) => void
  onEndEditing?: () => void
}
export const TextInput = ({ placeholder, value, onChangeText, onEndEditing }: Props) => {
  const onChange = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      onChangeText(event.target.value)
    },
    [onChangeText]
  )

  const onBlur = useCallback(() => {
    if (onEndEditing) {
      onEndEditing()
    }
  }, [onEndEditing])
  return (
    <TextInputNative id="outlined-basic" onBlur={onBlur} variant="standard" placeholder={placeholder} value={value} onChange={onChange} />
  )
}
